

export enum STATUS_REPAIR {
    WAITING = 'WAITING', //อยู่ระหว่างตรวจสอบ
    RECEIVE = 'RECEIVE', //รับคำร้อง
    ADDITIONAL = 'ADDITIONAL', //แจ้งเรื่องเพิ่มเติม
    SUCESS = 'SUCESS',//ดำเนินการแล้วเสร็จ
    DELETED = 'DELETED',
}


export const status_repair_data = (): { label: string, value: string }[] => {
    return [
        {
            label: "อัพเดตข้อมูล",
            value: STATUS_REPAIR.RECEIVE,
        },
        {
            label: "ดำเนินการแล้วเสร็จ",
            value: STATUS_REPAIR.SUCESS,
        },
    ]
}